import CrudManager from "@/components/admin/CrudManager";

export default function PackagesAdmin() {
  return (
    <CrudManager
      title="Tour Packages" subtitle="Manage Rajasthan tour packages." testid="admin-packages"
      endpoint={{ public: "/packages", admin: "/admin/packages" }} queryKey="packages"
      columns={[
        { key: "image", label: "Image", render: (p) => <img src={p.image} alt="" className="h-10 w-16 object-cover rounded-lg" /> },
        { key: "title", label: "Title" },
        { key: "duration", label: "Duration" },
      ]}
      fields={[
        { key: "title", label: "Package Title" },
        { key: "duration", label: "Duration (e.g. 2 Days)" },
        { key: "short", label: "Short Description", type: "textarea", rows: 2 },
        { key: "description", label: "Full Description", type: "textarea", rows: 4 },
        { key: "highlights", label: "Highlights (one per line)", type: "list", rows: 5 },
        { key: "image", label: "Image URL", type: "image", full: true },
        { key: "order", label: "Sort Order", type: "number" },
      ]}
    />
  );
}
